import React from 'react';
import { MultiSelectInput, MultiSelectInputProps, useInputHelper } from 'framework/form';

const formatDataForMultiSelectInput = (data: any[]) => {
  if (!data) {
    return [];
  }

  return data.map(item => ({
    value: item.name,
    label: item.name,
  }));
};

const SkillsInput = (props: MultiSelectInputProps) => {
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);

  const parentOnChange = getRawOnChangeCallback() || (() => {});

  const onChangeCallback = (obj: { [x: string]: any[] }) => {
    const mappedArray = obj[getSource()] || [];

    parentOnChange({
      [getSource()]: mappedArray.map(item => item.value),
    });
  };

  const noOptionsMessage = ({ inputValue }: any) =>
    inputValue.length ? 'Required Skill is not found.' : 'Start typing the name of the skill.';

  const value = getValue() || [];

  const mappedValue = value.map((item: any) => ({ value: item, label: item }));

  return (
    <MultiSelectInput
      {...props}
      onChangeCallback={onChangeCallback}
      mapResults={formatDataForMultiSelectInput}
      value={mappedValue}
      noOptionsMessage={noOptionsMessage}
      label="Skills"
    />
  );
};

export default SkillsInput;
